import React from "react";

function roundedPoly(points, r) {
  const n = points.length;
  let d = "";
  for (let i = 0; i < n; i++) {
    const prev = points[(i + n - 1) % n];
    const curr = points[i];
    const next = points[(i + 1) % n];
    const dx1 = curr[0] - prev[0],
      dy1 = curr[1] - prev[1];
    const len1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    const dx2 = next[0] - curr[0],
      dy2 = next[1] - curr[1];
    const len2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
    const t1 = Math.min(r / len1, 0.5);
    const t2 = Math.min(r / len2, 0.5);
    const p1 = [curr[0] - dx1 * t1, curr[1] - dy1 * t1];
    const p2 = [curr[0] + dx2 * t2, curr[1] + dy2 * t2];
    if (i === 0) d += `M ${p1[0].toFixed(2)} ${p1[1].toFixed(2)} `;
    else d += `L ${p1[0].toFixed(2)} ${p1[1].toFixed(2)} `;
    d += `Q ${curr[0].toFixed(2)} ${curr[1].toFixed(2)} ${p2[0].toFixed(2)} ${p2[1].toFixed(2)} `;
  }
  return d + "Z";
}

// size: 'sm' (desktop, ~36px) | 'md' (mobile, ~42px)
export default function RatingPentagon({ rating, size = "md" }) {
  const isSmall = size === "sm";
  const w = isSmall ? 36 : 42;
  const h = isSmall ? 38 : 44;
  const vw = 36,
    vh = 40;
  const cx = 18,
    cy = 20,
    r = isSmall ? 15 : 16;
  const cornerR = 3;
  const fontSize = isSmall ? 11 : 13;
  const textY = isSmall ? 23 : 24;

  const pts = Array.from({ length: 5 }, (_, i) => {
    const angle = (Math.PI * 2 * i) / 5 - Math.PI / 2;
    return [cx + r * Math.cos(angle), cy + r * Math.sin(angle)];
  });

  const pathD = roundedPoly(pts, cornerR);

  const gradId = `rpg-${rating}-${size}`;
  const fillColor =
    rating >= 4.5
      ? ["#22c55e", "#16a34a"]
      : rating >= 4.0
        ? ["#84cc16", "#65a30d"]
        : rating >= 3.5
          ? ["#eab308", "#ca8a04"]
          : ["#f97316", "#ea580c"];

  return (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${vw} ${vh}`}
      className="drop-shadow-md"
    >
      <defs>
        <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={fillColor[0]} />
          <stop offset="100%" stopColor={fillColor[1]} />
        </linearGradient>
      </defs>
      <path d={pathD} fill={`url(#${gradId})`} />
      <text
        x={cx}
        y={textY}
        textAnchor="middle"
        fontSize={fontSize}
        fontWeight="bold"
        fill="white"
        fontFamily="system-ui, sans-serif"
      >
        {rating}
      </text>
    </svg>
  );
}
